export const PROPS = {
    valueParser: {
        defaultValue: val => val
    }
};
